module.exports = __webpack_public_path__ + "static/img/190118-feature-vaccine.51c7409.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gensunicerse/190118-feature-vaccine.jpg
// module id = cg0I
// module chunks = 0